import styled, { css } from 'styled-components';
import { Container } from 'app/client/styled';
import { fadeInAnimation, reducedMotion } from 'app/client/styled/animations';

export const Wrapper = styled.div`
  position: relative;
  flex: 1 1 auto;
`;

export const Backdrop = styled.div`
  opacity: 0.4;
  filter: blur(4px);
  pointer-events: none;
  user-select: none;

  /* The shimmer runs inside the shadow DOM, out of reach of a plain selector. */
  wa-skeleton::part(indicator) {
    animation: none;
  }
`;

export const Card = styled(Container)`
  position: absolute;
  top: 10vh;
  left: 50%;
  transform: translateX(-50%);
  width: min(420px, calc(100% - 32px));
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
  padding: calc(2 * var(--lg-padding-vertical)) calc(2 * var(--lg-padding-horizontal));
  box-shadow: 0 10px 40px rgb(0 0 0 / 25%);
  animation: ${fadeInAnimation} 0.2s ease-out;

  ${reducedMotion(css`
    animation: none;
  `)}

  p {
    margin: 0 0 calc(1.5 * var(--lg-padding-vertical));
  }
`;

export const Gif = styled.div`
  width: 160px;
  height: 160px;
  border-radius: 80%;
  background: url('/public/images/pagenotfound.gif') top center / cover no-repeat;
`;

export const Title = styled.div`
  font-size: 2em;
  font-weight: bold;
  color: var(--red);
  margin: 0.25em 0;
`;
